module.exports = __webpack_public_path__ + "04e0ad26cc0c9126d3fc061702400f2f.png";